import type * as React from 'react';

function SvgInsight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M6.45312 11.9531H9.54688V12.6406H6.45312V11.9531ZM6.46257 13.6719C6.54806 14.4453 7.20378 15.0469 8 15.0469C8.79622 15.0469 9.45194 14.4453 9.53743 13.6719H6.46257ZM5.59375 10.9219V11.4375H5.42188V13.5C5.42188 14.9239 6.57614 16.0781 8 16.0781C9.42386 16.0781 10.5781 14.9239 10.5781 13.5V11.4375H10.4062V10.9219H5.59375Z"
        fill="#052643"
        fillRule="evenodd"
      />
      <path
        d="M10.1994 11.4375C11.3565 10.7119 12.125 9.43077 12.125 7.97135C12.125 5.709 10.2782 3.875 8 3.875C5.72183 3.875 3.875 5.709 3.875 7.97135C3.875 9.43077 4.64353 10.7119 5.80062 11.4375"
        stroke="#052643"
        strokeWidth="1.03125"
      />
      <path
        d="M7.3125 1.125C7.3125 0.745304 7.6203 0.4375 8 0.4375V0.4375C8.3797 0.4375 8.6875 0.745304 8.6875 1.125V2.54255C8.46228 2.51447 8.23283 2.5 8 2.5C7.76717 2.5 7.53772 2.51447 7.3125 2.54255V1.125Z"
        fill="#052643"
      />
      <path
        d="M4.62741 3.65507L3.62483 2.65249C3.35634 2.384 2.92104 2.384 2.65255 2.65249V2.65249C2.38407 2.92098 2.38407 3.35628 2.65255 3.62476L3.65513 4.62733C3.93743 4.26418 4.26425 3.93736 4.62741 3.65507Z"
        fill="#052643"
      />
      <path
        d="M2.54255 7.3125H1.125C0.745304 7.3125 0.4375 7.6203 0.4375 8V8C0.4375 8.3797 0.745304 8.6875 1.125 8.6875H2.54255C2.51447 8.46228 2.5 8.23283 2.5 8C2.5 7.76717 2.51447 7.53772 2.54255 7.3125Z"
        fill="#052643"
      />
      <path
        d="M13.4574 8.6875H14.875C15.2547 8.6875 15.5625 8.3797 15.5625 8V8C15.5625 7.6203 15.2547 7.3125 14.875 7.3125H13.4574C13.4855 7.53772 13.5 7.76717 13.5 8C13.5 8.23283 13.4855 8.46228 13.4574 8.6875Z"
        fill="#052643"
      />
      <path
        d="M12.345 4.6275L13.3477 3.62482C13.6162 3.35634 13.6162 2.92104 13.3477 2.65255V2.65255C13.0792 2.38407 12.6439 2.38407 12.3754 2.65255L11.3728 3.6552C11.7359 3.93751 12.0627 4.26434 12.345 4.6275Z"
        fill="#052643"
      />
    </svg>
  );
}

export default SvgInsight;
